var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticStyle:{"display":"flex","flex-direction":"column","align-items":"center"}},[(_vm.batteryStatus)?_c('icon',{staticStyle:{"transform":"scale(1.2)"},attrs:{"icon":_vm.batteryIcon,"width":"20"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }